import { Input } from '../../design/Input';
import { Select } from '../../design/Select';
import { Field } from './primitives';

const ADMIN_PASSWORD_GAMES = ['ark-se', 'rust', 'projectzomboid', 'palworld'];
const REGIONS = ['Europe', 'NorthAmericaEast', 'NorthAmericaWest', 'CentralAmerica', 'SouthAmerica', 'Russia', 'Asia', 'MiddleEast', 'Africa', 'Oceania'];

/** Spielregeln, an denen Server sonst kryptisch beim Start scheitern. */
export const validateSteamConfig = (slug: string | undefined, cfg: Record<string, any>): string | null => {
  if (slug === 'valheim') {
    const pw = String(cfg.password || '');
    if (pw.length < 5) return 'Valheim braucht ein Passwort mit mindestens 5 Zeichen.';
    if (String(cfg.name || '').toLowerCase().includes(pw.toLowerCase())) return 'Das Passwort darf nicht im Servernamen stehen (Valheim-Regel).';
  }
  return null;
};

interface Props {
  game: { slug: string; maps?: string[] | null } | null;
  cfg: Record<string, any>;
  onChange: (key: string, value: any) => void;
}

/** Spiel-Einstellungen eines Steam-Servers (gamemanager-steam.json) – wirken ab dem nächsten Start. */
export const SteamGameFields = ({ game, cfg, onChange }: Props) => {
  const slug = game?.slug;
  return (
    <div className="grid sm:grid-cols-2 gap-5">
      <Field label="Name im Serverbrowser">
        <Input value={cfg.name || ''} onChange={(e) => onChange('name', e.target.value)} />
      </Field>
      <Field label="Max. Spieler">
        <Input type="number" inputMode="numeric" min={1} value={cfg.maxPlayers ?? ''} onChange={(e) => onChange('maxPlayers', parseInt(e.target.value, 10) || 0)} />
      </Field>
      <Field label="Passwort" hint="Leer lassen = jeder kann joinen.">
        <Input value={cfg.password || ''} placeholder="leer = öffentlich" onChange={(e) => onChange('password', e.target.value)} />
      </Field>
      {slug && ADMIN_PASSWORD_GAMES.includes(slug) && (
        <Field label="Admin-Passwort" hint="Für Admin-Befehle im Spiel. Das Panel nutzt es auch für die Konsole – gilt ab dem nächsten Neustart.">
          <Input value={cfg.adminPassword || ''} onChange={(e) => onChange('adminPassword', e.target.value)} />
        </Field>
      )}
      {game?.maps && game.maps.length > 0 && (
        <Select label="Karte" value={cfg.map || game.maps[0]!} onChange={(v) => onChange('map', v)} options={game.maps.map((m) => ({ value: m, label: m }))} />
      )}
      {slug === 'sevendtd' && (
        <Select label="Region (Serverbrowser)" value={cfg.region || 'Europe'} onChange={(v) => onChange('region', v)} options={REGIONS.map((r) => ({ value: r, label: r }))} />
      )}
      {slug === 'dst' && (
        <div className="sm:col-span-2">
          <Field
            label="Klei Cluster-Token (für Online-Server)"
            hint="Ohne Token startet der Server nur im LAN. Kostenlos unter accounts.klei.com → Games → Don't Starve Together → Game Servers."
          >
            <Input value={cfg.clusterToken || ''} placeholder="pds-g^KU_…" onChange={(e) => onChange('clusterToken', e.target.value)} />
          </Field>
        </div>
      )}
      <div className="sm:col-span-2">
        <Field label="Zusätzliche Start-Parameter" hint="Nur wenn du weißt, was du tust – z.B. -NoBattlEye.">
          <Input value={cfg.extraArgs || ''} placeholder="optional" onChange={(e) => onChange('extraArgs', e.target.value)} />
        </Field>
      </div>
    </div>
  );
};
